export const getLang = (i18n?: any): "fr" | "en" => {
  // const { i18n } = useTranslation('common');
  return i18n?.language === "fr" ? "fr" : "en";
  // return "en"
};
